import styled from 'styled-components';

export default styled.div`
  ${props => props}
  color: ${props => props.theme.old.colors[props.color]};
  background-color: ${props => props.theme.old.colors[props.bg]};
  border: ${props => props.border + props.theme.old.colors[props.borderColor]};
  box-shadow: ${props => props.theme.old.shadow[props.shadow]};
  border-radius: ${props => props.theme.old.rounded[props.rounded]};
  transition: ${props => props.transition && props.theme.old.transition.default};
  background-image: ${({ bgImg }) => bgImg ? `url(${bgImg})` : ''};
  background-repeat: ${({ bgRepeat }) => bgRepeat};
  background-size: ${({ bgSize }) => bgSize};
  background-position: ${({ bgPos }) => bgPos};
  flex-direction: ${({ flexDir }) => flexDir};
  grid-gap: ${({ gap }) => gap};
  width:${({width}) => width};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  opacity: ${props => props.theme.old.opacity[props.opacity]};
`;